import React, { ReactElement } from 'react';
import { Container } from '@sm/wds-react';

import { HeaderTypeEnum, HeaderImagePropsType } from '../../types';

const Logo = (props: HeaderImagePropsType): ReactElement => {
  const { headerType, url, altText } = props;
  return (
    <If condition={url}>
      <Container className="sm-enterprise-thank-you__header-logo" flex flexJustify="center">
        <Choose>
          <When condition={headerType === HeaderTypeEnum.PREMIUM}>
            <img data-testid="Logo__Premium" className="sm-enterprise-thank-you__logo" src={url} alt={altText || ''} />
          </When>
          <Otherwise>
            <img data-testid="Logo__Standard" className="sm-enterprise-thank-you__logo" src={url} alt={altText || ''} />
          </Otherwise>
        </Choose>
      </Container>
    </If>
  );
};

export default Logo;
